import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CustomTooltip from './CustomTooltip';

const useStyles = makeStyles(theme => ({
  root: {
    border: '1px solid transparent',
    '&:hover': {
      border: `1px solid ${theme.palette.common.tealish}`,
    },
  },
  icon: {
    fontSize: '1rem',
  },
}));

const classNames = (...names) => {
  return names.filter(name => name !== undefined).join(' ');
};

const ControlIconButton = ({label, to, onClick, icon=null, color='primary', disabled=false, className=undefined, ...props}) => {
  const classes = useStyles();
  const action = to ? {component: Link, to: to} : {onClick : onClick};
  return (
    <CustomTooltip
      arrow
      placement="bottom-end"
      title={label}
    >
      <IconButton
        className={classNames(classes.root, className)}
        color={color}
        disabled={disabled}
        disableRipple
        {...action}
        {...props}
      >
        {icon === 'more' ? <MoreVertIcon className={classes.icon} /> : null}
        {icon === 'download' ? <ArrowDownwardIcon className={classes.icon} /> : null}
        {icon === 'forward' ? <ArrowForwardIcon className={classes.icon} /> : null}
      </IconButton>
    </CustomTooltip>
  );
};

ControlIconButton.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  icon: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default ControlIconButton;
